import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import vuetify from './plugins/vuetify'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import AuthService from './auth/AuthService'
import NProgress from 'nprogress'
import vueMoment from 'vue-moment'
import VueTour from 'vue-tour'
import UUID from 'vue-uuid'
import { VueMaskDirective } from 'v-mask'
import 'nprogress/nprogress.css'
import VueMixpanel from 'vue-mixpanel'
// Importing all css styles
import './lib/globalCss'

import { Auth0Plugin } from './auth'
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID } from './utils/constants'
require('vue-tour/dist/vue-tour.css')

const useAuth0Login = process.env.VUE_APP_USE_AUTH0_LOGIN === 'true'

Vue.prototype.$useAuth0Login = useAuth0Login

setInterval(function () {
  const expiresAt = localStorage.getItem('reveles-expires-at')
  if (expiresAt && parseInt(expiresAt) < Date.now()) {
    store.dispatch('signOutUserFromApi')
    router.push('session/login')
  }
}, 10000)

if (useAuth0Login) {
  Vue.use(Auth0Plugin, {
    domain: AUTH0_DOMAIN,
    clientId: AUTH0_CLIENT_ID,
    cacheLocation: 'localstorage',
    onRedirectCallback: async appState => {
      const { $auth, $store } = router.app
      if ($auth.error) {
        $store.dispatch('signOutUserFromApi', router)
          .then(() => {
            $auth.logout()
          })
        return
      }
      const claims = await $auth.getIdTokenClaims()
      const id_token = claims.__raw
      const access_token = await $auth.getTokenSilently()
      $store.dispatch('getUserLogin', { id_token, access_token, redirect: '/' })
        .then(() => {
          const user = JSON.parse(localStorage.getItem('reveles-user'))
          if ($auth.isAuthenticated && (!Object.prototype.hasOwnProperty.call(user, 'eula_accepted') || !user.eula_accepted)) {
            router.push('/eula')
          } else {
            router.push(
              appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
            )
          }
        })
    }
  })
}

router.beforeEach((to, from, next) => {
  if (useAuth0Login) {
    NProgress.start()
    const { $auth } = router.app
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const fn = () => {
        const user = JSON.parse(localStorage.getItem('reveles-user'))
        if ($auth.isAuthenticated) {
          if ((!Object.prototype.hasOwnProperty.call(user, 'eula_accepted') || !user.eula_accepted) && to.path !== '/eula') {
            return next('/eula')
          } else {
            return next()
          }
        } else {
          $auth.loginWithRedirect({
            redirect_uri: window.location.origin + '/callback',
            appState: { targetUrl: to.fullPath },
            scope: process.env.VUE_APP_AUTH0_SCOPE
          })
        }
      }

      if (!$auth.loading) {
        return fn()
      }

      $auth.$watch('loading', loading => {
        if (loading === false) {
          return fn()
        }
      })
    } else {
      next()
    }
  } else {
    const auth = new AuthService()
    const authenticated = auth.authenticated
    const user = JSON.parse(localStorage.getItem('reveles-user'))
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const expiresAt = localStorage.getItem('reveles-expires-at')
      if (localStorage.getItem('reveles-user') === null || !authenticated || !expiresAt || parseInt(expiresAt) < Date.now()) {
        next({
          path: '/session/login',
          query: { redirect: to.fullPath }
        })
      } else if (!Object.prototype.hasOwnProperty.call(user, 'eula_accepted') || !user.eula_accepted) {
        if (to.name === 'eula') {
          next()
        } else next('/eula')
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  setTimeout(() => {
    const contentWrapper = document.querySelector('.v-content__wrap')
    if (contentWrapper !== null) {
      contentWrapper.scrollTop = 0
    }
    const boxedLayout = document.querySelector('.app-boxed-layout .app-content')
    if (boxedLayout !== null) {
      boxedLayout.scrollTop = 0
    }
    const miniLayout = document.querySelector('.app-mini-layout .app-content')
    if (miniLayout !== null) {
      miniLayout.scrollTop = 0
    }
  }, 200)
  // Complete the animation of the route progress bar.
  NProgress.done()
})

Vue.config.productionTip = false
Vue.directive('mask', VueMaskDirective)
Vue.use(Notifications, { velocity })
Vue.use(vueMoment)
Vue.use(VueTour)
Vue.use(UUID)
Vue.use(VueMixpanel, {
  token: process.env.VUE_APP_MIX_PANEL_TOKEN
})

// global variables

Vue.prototype.$appVersion = '1.3.148'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
